import { faClone } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment, useState } from "react";
import styled from "styled-components";
import Button from "../../../components/Button";
import Colors from "../../../styles/Colors";
import { H2 } from "../../../styles/Fonts";
import CreateReferralCodeModal from "./CreateReferralCodeModal";

const UserCode: React.FC<{
  referralCode?: string;
  updateReferralCode: () => void;
}> = (props) => {
  const { referralCode, updateReferralCode } = props;

  const [modalIsShow, setModalIsShow] = useState<boolean>(false);
  const [isCreating, setIsCreating] = useState<boolean>(false);

  const onCopy = () => {
    navigator.clipboard.writeText(
      `${window.location.origin}?code=${referralCode}`
    );
  };

  return (
    <Container>
      <TopContainer>
        <MyCodeLabel>My Code : </MyCodeLabel>
        {!!referralCode ? (
          <Fragment>
            <MyCodeValue>{referralCode}</MyCodeValue>
            <CopyBtn onClick={onCopy}>
              <CopyIcon icon={faClone} />
              <span>Copy Referral Link</span>
            </CopyBtn>
          </Fragment>
        ) : (
          <BtnContainer>
            <Button
              btnType="primary"
              btnText="Create Referral Code"
              onClick={() => setModalIsShow(true)}
              disabled={isCreating}
              isLoading={isCreating}
            />
          </BtnContainer>
        )}
      </TopContainer>
      <CreateReferralCodeModal
        isShowModal={modalIsShow}
        setShowModal={setModalIsShow}
        setIsCreating={setIsCreating}
        updateReferralCode={updateReferralCode}
      />
    </Container>
  );
};

export default UserCode;

const Container = styled.div``;

const TopContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 40px 0;
`;

const MyCodeLabel = styled(H2)`
  display: inline;
  font-size: 18px;
  line-height: 24px;
  color: ${Colors.ivory};
`;

const MyCodeValue = styled(H2)`
  display: inline-block;
  font-size: 20px;
  line-height: 24px;
  font-weight: bold;
  color: ${Colors.ivory};
  margin-left: 12px;
`;

const CopyBtn = styled.button`
  font-size: 14px;
  line-height: 20px;
  font-weight: bold;
  padding: 6px 12px;
  margin-left: 20px;
  color: ${Colors.lightKhaki};
  border: 1px solid ${Colors.lightKhaki};
  border-radius: 8px;
  display: flex;
  align-items: center;
  :active {
    transform: scale(0.99);
  }
`;

const CopyIcon = styled(FontAwesomeIcon)`
  font-size: 15px;
  margin-right: 8px;
`;

const BtnContainer = styled.div`
  margin-left: 12px;
`;
